import { ReactElement } from 'react';

import { StepHome } from '../components/_pages/StepHome/StepHome';
import { Step1 } from '../components/_pages/Step1/Step1';
import { Step10 } from '../components/_pages/Step10/Step10';
import { Step11 } from '../components/_pages/Step11/Step11';
import { Step2 } from '../components/_pages/Step2/Step2';
import { Step3 } from '../components/_pages/Step3/Step3';
import { Step4 } from '../components/_pages/Step4/Step4';
import { Step5 } from '../components/_pages/Step5/Step5';
import { Step6 } from '../components/_pages/Step6/Step6';
import { Step7 } from '../components/_pages/Step7/Step7';
import { Step8 } from '../components/_pages/Step8/Step8';
import { Step9 } from '../components/_pages/Step9/Step9';
import { Step9a } from '../components/_pages/Step9a/Step9a';
import { Step9b } from '../components/_pages/Step9b/Step9b';
import { Step9c } from '../components/_pages/Step9c/Step9c';
import { Step9loading } from '../components/_pages/Step9loading/Step9loading';
import { StepConfirmData } from '../components/_pages/StepConfirmData/StepConfirmData';
import { NoEntry } from '../components/_pages/NoEntry/NoEntry';
import { Error } from '../components/_pages/Error/Error';
import config from '../config.json';
import { StepBankId } from '../components/_pages/StepBankId/StepBankId';
import { StepLead } from '../components/_pages/StepLead/StedLead';
import { Test } from '../components/_pages/Test/TestWaitForLocal';
import { Step10processing } from '../components/_pages/Step10processing/Step10processing';
import { routesMeta } from './routesMeta';

const componentsByUrl: { [url: string]: ReactElement } = {
    '/': <StepHome />,
    [`/${config.SLUGS.STEP1A_SLUG}/`]: <Step1 />,
    [`/${config.SLUGS.STEP1B_SLUG}/`]: <Step1 />,
    [`/${config.SLUGS.STEP1C_SLUG}/`]: <Step9b />,
    [`/${config.SLUGS.STEP2A_SLUG}/`]: <Step2 />,
    [`/${config.SLUGS.STEP2B_SLUG}/`]: <Step2 />,
    [`/${config.SLUGS.STEP3_SLUG}/`]: <Step3 />,
    [`/${config.SLUGS.STEP4_SLUG}/`]: <Step4 />,
    [`/${config.SLUGS.STEP5_SLUG}/`]: <Step5 />,
    [`/${config.SLUGS.STEP6_SLUG}/`]: <Step6 />,
    [`/${config.SLUGS.STEP7_SLUG}/`]: <Step7 />,
    [`/${config.SLUGS.STEP8_SLUG}/`]: <Step8 />,
    [`/${config.SLUGS.STEP9LOADING_SLUG}/`]: <Step9loading />,
    [`/${config.SLUGS.STEP9_SLUG}/`]: <Step9 />,
    [`/${config.SLUGS.STEP9A_SLUG}/`]: <Step9a />,
    [`/${config.SLUGS.STEP9B_SLUG}/`]: <Step9b />,
    [`/${config.SLUGS.STEP9C_SLUG}/`]: <Step9c />,
    [`/${config.SLUGS.STEP_BANK_ID_SLUG}/`]: <StepBankId />,
    [`/${config.SLUGS.STEP_CONFIRMDATA_SLUG}/`]: <StepConfirmData />,
    [`/${config.SLUGS.STEP10PROCESSING_SLUG}/`]: <Step10processing />,
    [`/${config.SLUGS.STEP10_SLUG}/`]: <Step10 />,
    [`/${config.SLUGS.STEP11_SLUG}/`]: <Step11 />,
    [`/${config.SLUGS.STEP_LEAD_SLUG}/`]: <StepLead />,
    [`/${config.SLUGS.NOENTRY_SLUG}/`]: <NoEntry />,
    '*': <Error code="404" />,
    [`/${config.SLUGS.SERVERERR_SLUG}/`]: <Error code="500" />,
    [`/${config.SLUGS.TEST}/`]: <Test />,
};

export const routes = routesMeta.map((route) => ({
    ...route,
    component: componentsByUrl[route.url],
}));
